function sideHeader() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./side-header.html'),
    scope: {
      name: '@',
      theme: '@',
      docs: '@',
      app: '=',
      icon: '@',
      details: '@'
    }
  };
}
export { sideHeader };
